<template>
  <div class="config">
    <el-tabs tab-position="left">
      <el-tab-pane label="开发者ID">
        <el-form label-width="160px" label-position="left" :model="formData">
          <el-card class="c-card" shadow="hover" v-for="(item, i) in formData.appidArr" :key="i">
            <div slot="header" class="c-card-header">
              <span class="c-w-500">{{ formatAppID(item.appID) }}</span>
              <div>
                <el-button icon="el-icon-plus" type="primary" circle @click="add(i)"></el-button>
                <el-button
                  icon="el-icon-close"
                  type="danger"
                  circle
                  v-if="formData.appidArr.length > 1"
                  @click="remove(i)"
                ></el-button>
              </div>
            </div>
            <el-form-item label="AppID(小程序ID)">
              <el-input v-model="item.appID" @blur="doSave"></el-input>
            </el-form-item>
            <el-form-item label="AppSecret(小程序密钥)">
              <el-input v-model="item.appSecret" @blur="doSave"></el-input>
            </el-form-item>
          </el-card>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="数据字典">
        <el-card class="c-card" shadow="hover">
          <div slot="header" class="c-card-header">
            <span class="c-w-500">省/市/区/街道</span>
          </div>
          <el-button type="primary" @click="updateArea">更新文件</el-button>
        </el-card>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
export default {
  activated() {
    window.$this = this;
  },
  name: 'Config',
  data() {
    window.$this = this;
    return {
      options: {
        codecfg_appID: { codeId: 'appID' }
      },
      formData: {
        appidMap: {},
        appidArr: []
      }
    };
  },
  mounted() {
    this.osg.codeoption(() => {
      this.getData();
    });
  },
  methods: {
    getData() {
      this.osg.ajax('/config/query.do', {}, res => {
        // 对象转数组
        res.appidArr = [];
        for (let key in res.appidMap) {
          res.appidArr.push({ appID: key, appSecret: res.appidMap[key] });
        }

        this.formData = res;
      });
    },
    doSave() {
      // 数组转对象
      this.formData.appidMap = {};
      for (let item of this.formData.appidArr) {
        if (!item.appID || !item.appSecret) {
          this.osg.toast('请输入AppID和AppSecret！', 'warning');
          return;
        }
        this.formData.appidMap[item.appID] = item.appSecret;
      }
      delete this.formData.appidArr;
      this.osg.ajax(
        '/config/upsert.do',
        this.formData,
        () => {
          this.getData();
        },
        {
          noload: true
        }
      );
    },
    add(i) {
      this.formData.appidArr.splice(i + 1, 0, { appID: '', appSecret: '' });
    },
    remove(i) {
      this.osg.confirm('是否确认删除？', () => {
        this.formData.appidArr.splice(i, 1);
        this.doSave();
      });
    },
    formatAppID(appID) {
      let appName = this.osg.codelabel('appID', appID);
      return appName == '未知' ? '开发者ID' : appName;
    },
    // 更新省/市/区/街道文件
    updateArea() {
      this.osg.toast('已提交更新，待生成文件后生效。');
      this.osg.ajax('area/updateAreaFile.do', {}, () => {});
    }
  }
};
</script>
<style scoped lang="scss">
.config {
  padding: 10px 10px 10px 0;
  ::v-deep .el-tabs__header {
    min-width: 150px;
  }
  ::v-deep .el-tabs__content {
    height: 100%;
    overflow-y: auto;
  }
  .c-card {
    max-width: 500px;
    margin-bottom: 15px;
    ::v-deep .el-card__header {
      padding: 10px;
      .c-card-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
    }
  }
}
</style>
